/* eslint-disable */
const extractYouTubeVideoId = (link: string | undefined) => {
    if (link){
        const url = new URL(link);
        if (url.hostname === 'www.youtube.com' || url.hostname === 'youtube.com'){
            const searchParams = new URLSearchParams(url.search);
            return searchParams.get('v');
        }
    }
    return null;
}

export default extractYouTubeVideoId
